import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ICompanyVoteResultListState } from '../states/company-vote-result-list.state';

export const selectCompanyVoteResultListState = createFeatureSelector<ICompanyVoteResultListState>('companyVoteResultList');

export const selectCompanyVoteResultSearchFilter = createSelector(
  selectCompanyVoteResultListState,
  (state: ICompanyVoteResultListState) => state.searchFilter
);

export const selectCompanyVoteResultPagination = createSelector(
  selectCompanyVoteResultListState,
  (state: ICompanyVoteResultListState) => ({
    currentPage: state.currentPage,
    pageSize: state.pageSize
  })
);

export const selectCompanyVoteResultSort = createSelector(
  selectCompanyVoteResultListState,
  (state: ICompanyVoteResultListState) => ({
    sortBy: state.sortBy,
    ascending: state.ascending
  })
);

export const selectCompanyVoteResultListFullState = createSelector(
  selectCompanyVoteResultListState,
  (state: ICompanyVoteResultListState) => state
);
